import { createSimpleTransition } from '../../utils/helpers'

export const SlideXTransition = createSimpleTransition('slide-x-transition')
export const SlideXReverseTransition = createSimpleTransition('slide-x-reverse-transition')
export const SlideYTransition = createSimpleTransition('slide-y-transition')
export const SlideYReverseTransition = createSimpleTransition('slide-y-reverse-transition')
export const ScaleTransition = createSimpleTransition('scale-transition')
export const DialogTransition = createSimpleTransition('dialog-transition')
export const DialogBottomTransition = createSimpleTransition('dialog-bottom-transition')
export const DialogRightTransition = createSimpleTransition('dialog-right-transition')
export const FadeTransition = createSimpleTransition('fade-transition')
export const SnackBarTopTransition = createSimpleTransition('snack-bar-top-transition')
export const SnackBarBottomTransition = createSimpleTransition('snack-bar-bottom-transition')
